// import React, { useState, useMemo, useCallback } from 'react';
// import { MaterialReactTable } from 'material-react-table';
// import { Box, Typography, TextField, Button, Tooltip } from '@mui/material';
// import FileDownloadIcon from '@mui/icons-material/FileDownload';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import SortIcon from '@mui/icons-material/Sort';
// import { mkConfig, generateCsv, download } from 'export-to-csv';

// // Helper function to get date in YYYY-MM-DD format
// const getForecastDate = (offset = 0) => {
//   const date = new Date();
//   date.setDate(date.getDate() + offset);
//   return date.toISOString().slice(0, 10);
// };

// // Configuration for CSV export
// const csvConfig = mkConfig({
//   fieldSeparator: ',',
//   decimalSeparator: '.',
//   useKeysAsHeaders: true,
//   filename: 'landslide_impact_forecast',
// });

// const ImpactedArea_LS = ({ loading, tableData, selectedDateIndex }) => {
//   const [activeFilter, setActiveFilter] = useState('High');

//   const forecastDates = useMemo(
//     () => [getForecastDate(0), getForecastDate(1), getForecastDate(2)],
//     []
//   );

//   const legendColors = useMemo(
//     () => ({
//       NoRisk: 'rgb(148, 203, 85)',
//       Low: 'rgb(243, 235, 18)',
//       Medium: 'rgb(243, 155, 58)',
//       High: 'rgb(230, 45, 58)',
//       'N/A': 'rgb(222,222,223)',
//       All: '#f0f0f0',
//     }),
//     []
//   );

//   const characteristicKey = `CharacteristicDay${selectedDateIndex + 1}`;
//   const headerDate = forecastDates[selectedDateIndex];

//   const combinedFilteredData = useMemo(() => {
//     let currentData = tableData || [];

//     if (activeFilter !== 'All') {
//       currentData = currentData.filter(
//         (item) => item[characteristicKey] === activeFilter
//       );
//     }

//     return currentData.sort(
//       (a, b) =>
//         (a.Municipality || '').localeCompare(b.Municipality || '') ||
//         (a.PostAdmin || '').localeCompare(b.PostAdmin || '') ||
//         (a.Suco || '').localeCompare(b.Suco || '')
//     );
//   }, [tableData, activeFilter, characteristicKey]);

//   const handleExportData = useCallback(() => {
//     try {
//       if (!combinedFilteredData.length) {
//         console.warn('No data to export.');
//         return;
//       }

//       const dataToExport = combinedFilteredData.map((row) => ({
//         Municipality: row.Municipality || '',
//         'Post Admin': row.PostAdmin || '',
//         Suco: row.Suco || '',
//         [`Risk Characteristic (${headerDate})`]:
//           row[characteristicKey] || 'N/A',
//         'Total Population': row.Population || 0,
//         'Total Male': row.Male || 0,
//         'Total Female': row.Female || 0,
//         'Total Children (under 17)': row.HH_Urban || 0,
//         'Total Elderly': row.HH_Rural || 0,
//         Household: row.Household || 0,
//       }));

//       const csv = generateCsv(csvConfig)(dataToExport);
//       download(csvConfig)(csv);
//     } catch (e) {
//       console.error('Error during CSV export:', e);
//     }
//   }, [combinedFilteredData, headerDate, characteristicKey]);

//   const columns = useMemo(() => {
//     const getCharacteristicColor = (characteristic) =>
//       legendColors[characteristic] || legendColors['N/A'];

//     return [
//       {
//         accessorKey: 'SlNo',
//         header: 'Sl No',
//         size: 50,
//         enableColumnFilter: false,
//         enableSorting: true,
//         Cell: ({ row }) => row.index + 1,
//       },
//       {
//         accessorKey: 'Municipality',
//         header: 'Municipality',
//         size: 150,
//         Filter: ({ column }) => (
//           <TextField
//             variant="standard"
//             placeholder="Filter by M..."
//             value={column.getFilterValue() ?? ''}
//             onChange={(e) => column.setFilterValue(e.target.value)}
//             sx={{ width: '100%' }}
//             InputProps={{ disableUnderline: true }}
//           />
//         ),
//       },
//       {
//         accessorKey: 'PostAdmin',
//         header: 'Post Admin',
//         size: 150,
//         Filter: ({ column }) => (
//           <TextField
//             variant="standard"
//             placeholder="Filter by P..."
//             value={column.getFilterValue() ?? ''}
//             onChange={(e) => column.setFilterValue(e.target.value)}
//             sx={{ width: '100%' }}
//             InputProps={{ disableUnderline: true }}
//           />
//         ),
//       },
//       {
//         accessorKey: 'Suco',
//         header: 'Suco',
//         size: 150,
//         Filter: ({ column }) => (
//           <TextField
//             variant="standard"
//             placeholder="Filter by S..."
//             value={column.getFilterValue() ?? ''}
//             onChange={(e) => column.setFilterValue(e.target.value)}
//             sx={{ width: '100%' }}
//             InputProps={{ disableUnderline: true }}
//           />
//         ),
//       },
//       {
//         accessorKey: characteristicKey,
//         header: 'Characteristics',
//         Cell: ({ cell }) => (
//           <span
//             style={{
//               backgroundColor: getCharacteristicColor(cell.getValue()),
//               padding: '2px 5px',
//               borderRadius: '3px',
//               display: 'inline-block',
//               color: 'black',
//               fontWeight: 'bold',
//             }}
//           >
//             {cell.getValue()}
//           </span>
//         ),
//         size: 150,
//         filterFn: 'includesString',
//         Filter: ({ column }) => (
//           <TextField
//             variant="standard"
//             placeholder="Filter by Char..."
//             value={column.getFilterValue() ?? ''}
//             onChange={(e) => column.setFilterValue(e.target.value)}
//             sx={{ width: '100%' }}
//             InputProps={{ disableUnderline: true }}
//           />
//         ),
//       },
//       {
//         accessorKey: 'Population',
//         header: 'Total Population',
//         size: 150,
//       },
//       { accessorKey: 'Male', header: 'Total Male', size: 150 },
//       { accessorKey: 'Female', header: 'Total Female', size: 150 },
//       {
//         accessorKey: 'HH_Urban',
//         header: 'Total Children (under 17)',
//         size: 150,
//       },
//       { accessorKey: 'HH_Rural', header: 'Total Elderly', size: 150 },
//       { accessorKey: 'Household', header: 'Household', size: 150 },
//     ];
//   }, [legendColors, characteristicKey]);

//   const filterButtons = useMemo(() => {
//     const riskLevels = ['High', 'Medium', 'Low', 'NoRisk', 'All'];
//     return riskLevels.map((level) => (
//       <Button
//         key={level}
//         onClick={() => setActiveFilter(level)}
//         sx={{
//           minWidth: '90px',
//           padding: '8px 14px',
//           borderRadius: '10px',
//           fontWeight: '500',
//           fontSize: '14px',
//           cursor: 'pointer',
//           transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//           textTransform: 'none',
//           ml: 1,
//           mr: 1,
//           backgroundColor: legendColors[level],
//           color: 'black',
//           border:
//             activeFilter === level
//               ? '1px solid #333'
//               : '2px solid transparent',
//           boxShadow:
//             activeFilter === level
//               ? '0 4px 12px rgba(0, 0, 0, 0.3)'
//               : '0 2px 4px rgba(0, 0, 0, 0.1)',
//           '&:hover': {
//             backgroundColor: legendColors[level],
//             opacity: 0.9,
//             transform: 'translateY(-3px)',
//             boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)',
//           },
//           '&:active': {
//             transform: 'translateY(-1px)',
//           },
//         }}
//       >
//         {level === 'NoRisk' ? 'No Risk' : level}
//       </Button>
//     ));
//   }, [activeFilter, legendColors]);

//   return (
//     <div className="info-content-text">
//       <Box
//         sx={{
//           p: 0,
//           borderTop: 'none',
//           overflow: 'auto',
//           width: '100%',
//           background: '#f5f7fa',
//           minHeight: '100vh',
//         }}
//       >
//         {/* Filter Section */}
//         <Box
//           sx={{
//             mx: 2,
//             mb: 1,
//             p: 1,
//             backgroundColor: '#fff',
//             borderRadius: '12px',
//             boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
//             display: 'flex',
//             alignItems: 'center',
//             gap: 2,
//             flexWrap: 'wrap',
//           }}
//         >
//           <SortIcon sx={{ color: '#2563eb', fontSize: 28 }} />
//           <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#333' }}>
//             Filter By Risk Level:
//           </Typography>
//           <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', flex: 1, p: 1 }}>
//             {filterButtons}
//           </Box>
//         </Box>

//         {/* Table Section */}
//         <Box
//           sx={{
//             mx: 2,
//             mb: 3,
//             backgroundColor: '#fff',
//             borderRadius: '12px',
//             boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
//             overflow: 'hidden',
//           }}
//         >
//           <MaterialReactTable
//             columns={columns}
//             data={combinedFilteredData}
//             state={{ isLoading: loading }}
//             enableColumnFilters
//             enableColumnActions
//             enableSorting
//             enablePagination
//             enableDensityToggle
//             enableFullScreenToggle
//             enableGlobalFilter
//             paginationDisplayMode="pages"
//             initialState={{
//               columnVisibility: { SlNo: true },
//               density: 'compact',
//               pagination: { pageSize: 10 },
//             }}
//             muiTableContainerProps={{ sx: { maxHeight: '600px', backgroundColor: '#fafafa' } }}
//             muiTableHeadCellProps={{
//               sx: {
//                 fontWeight: 'bold',
//                 backgroundColor: '#2563eb',
//                 color: '#fff',
//                 fontSize: '0.95rem',
//                 padding: '12px',
//                 borderBottom: '3px solid #1e40af',
//               },
//             }}
//             muiTableBodyCellProps={{
//               sx: {
//                 padding: '10px 12px',
//                 borderBottom: '1px solid #e0e0e0',
//                 '&:hover': {
//                   backgroundColor: '#f8f9ff',
//                 },
//               },
//             }}
//             muiTableBodyRowProps={{
//               sx: {
//                 '&:hover': {
//                   backgroundColor: '#f5f7ff',
//                   boxShadow: '0 2px 8px rgba(102, 126, 234, 0.1)',
//                 },
//               },
//             }}
//             renderEmptyRowsFallback={() => (
//               <Box sx={{ p: 3, textAlign: 'center' }}>
//                 <Typography variant="body1" color="#999">
//                   No impact data found for the selected filter.
//                 </Typography>
//               </Box>
//             )}
//             renderTopToolbarCustomActions={({ table }) => (
//               <Box
//                 sx={{
//                   display: 'flex',
//                   flexDirection: 'row',
//                   alignItems: 'center',
//                   justifyContent: 'space-between',
//                   flexWrap: 'wrap',
//                   width: '100%',
//                   p: '12px 16px',
//                   // backgroundColor: '#f8f9ff',
//                   // borderBottom: '2px solid #e0e0e0',
//                   backgroundColor: "#ffffff",
//                   gap: '1rem',
//                 }}
//               >
//                 <Typography variant="body1" fontWeight="bold" sx={{ color: '#2563eb' }}>
//                   Date: {headerDate}
//                 </Typography>
//                 <Tooltip title="Export filtered data to CSV">
//                   <Button
//                     onClick={handleExportData}
//                     disabled={!combinedFilteredData.length}
//                     variant="contained"
//                     sx={{
//                       backgroundColor: '#2563eb',
//                       color: '#fff',
//                       textTransform: 'none',
//                       fontWeight: 'bold',
//                       borderRadius: '20px',
//                       padding: '8px 16px',
//                       transition: 'all 0.3s ease',
//                       '&:hover': {
//                         backgroundColor: '#1e40af',
//                         transform: 'translateY(-2px)',
//                         boxShadow: '0 4px 12px rgba(37, 99, 235, 0.4)',
//                       },
//                       '&.Mui-disabled': {
//                         backgroundColor: '#ccc',
//                         color: '#666',
//                       },
//                     }}
//                   >
//                     <FileDownloadIcon sx={{ mr: 1 }} />
//                     Export CSV
//                   </Button>
//                 </Tooltip>
//               </Box>
//             )}
//           />
//         </Box>

//         {/* Footer Stats */}
//         <Box
//           sx={{
//             mx: 2,
//             mb: 3,
//             p: 2,
//             backgroundColor: '#fff',
//             borderRadius: '12px',
//             boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
//             display: 'grid',
//             gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
//             gap: 2,
//           }}
//         >
//           <Box sx={{ textAlign: 'center', p: 1 }}>
//             <Typography variant="caption" sx={{ color: '#999' }}>
//               Total Records
//             </Typography>
//             <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2563eb' }}>
//               {combinedFilteredData.length}
//             </Typography>
//           </Box>
//           <Box sx={{ textAlign: 'center', p: 1 }}>
//             <Typography variant="caption" sx={{ color: '#999' }}>
//               Active Filter
//             </Typography>
//             <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1e40af' }}>
//               {activeFilter}
//             </Typography>
//           </Box>
//         </Box>
//       </Box>
//     </div>
//   );
// };

// export default ImpactedArea_LS;



import { useMemo } from "react";
import CommonTable from "../../../common/CommonTable";
import { getLandslideCharacteristic, riskRank } from "./reportGenerator_LS.js";

const ImpactedArea_LS = ({ tableData = [], selectedDateIndex = 0 }) => {

  const characteristicKey = `CharacteristicDay${selectedDateIndex + 1}`;

  // Rows come out ordered High, Medium, Low, No Risk (N/A last), then by
  // Municipality / Post Admin / Suco. Sorting the Risk column uses the same order.
  const mappedData = useMemo(() => {
    return [...tableData]
      .sort((a, b) =>
        riskRank(getLandslideCharacteristic(a[characteristicKey])) - riskRank(getLandslideCharacteristic(b[characteristicKey])) ||
        (a.Municipality || "").localeCompare(b.Municipality || "") ||
        (a.PostAdmin || "").localeCompare(b.PostAdmin || "") ||
        (a.Suco || "").localeCompare(b.Suco || "")
      )
      .map((row) => ({
      Municipality: row.Municipality,
      PostAdmin: row.PostAdmin,
      Suco: row.Suco,
      Population: row.Population,
      Male: row.Male,
      Female: row.Female,
      Children: row.HH_Urban,
      Elderly: row.HH_Rural,
      Household: row.Household,
      advisory: row[characteristicKey] || "N/A", // 🔥 IMPORTANT
    }));
  }, [tableData, characteristicKey]);

  const columns = [
    { key: "SlNo", label: "Sl No" },
    { key: "Municipality", label: "Municipality", sortable: true },
    { key: "PostAdmin", label: "Post Admin", sortable: true },
    { key: "Suco", label: "Suco", sortable: true },
    {
      key: "advisory",
      label: "Risk",
      sortable: true,
      sortValue: (row) => riskRank(getLandslideCharacteristic(row.advisory)),
      render: (row, getColor) => (
        <span
          style={{
            background: getColor(row.advisory),
            padding: "3px 6px",
            borderRadius: "4px",
            fontWeight: "bold",
          }}
        >
          {row.advisory}
        </span>
      ),
    },
    { key: "Population", label: "Population" },
    { key: "Male", label: "Male" },
    { key: "Female", label: "Female" },
    { key: "Children", label: "Children" },
    { key: "Elderly", label: "Elderly" },
    { key: "Household", label: "Household" },
  ];

  const legendColors = {
    High: "rgb(230,45,58)",
    Medium: "rgb(243,155,58)",
    Low: "rgb(243,235,18)",
    NoRisk: "rgb(148,203,85)",
  };

  return (
    <CommonTable
      tableData={mappedData}
      columns={columns}
      showFilter
      filterOptions={["High", "Medium", "Low", "NoRisk", "All"]}
      legendColors={legendColors}
      defaultSort={{ key: "advisory", direction: "asc" }}
      searchableKeys={["Municipality", "PostAdmin", "Suco"]}
      tableName="Landslide_Impact"
    />
  );
};

export default ImpactedArea_LS;